/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./AdminLogin.css";
import { Textbox } from "../../assets/component/Textbox";
import { validLogin } from "../../assets/validators/login.js";
import PropTypes from "prop-types";

class AdminLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      usernameHasErr: true,
    };

    this.handleChange = this.handleChange.bind(this);
    this.reroute = this.reroute.bind(this);
  }

  handleChange(e) {
    this.setState({ username: e });
  }

  reroute() {
    if (!this.state.usernameHasErr) {
      this.props.history.push({
        pathname: "/AdminLoginPassword",
        state: {
          username: this.state.username,
        },
      });
    }
  }

  render() {
    const languageObj = this.props.languageObj;

    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        this.reroute();
      }
    };

    return (
      <div className="AdminLogin-view">
        <div className="AdminLogin-prompt">
          <div className="AdminLogin-logo"></div>

          <div className="AdminLogin-text1">Welcome Team!</div>

          <div className="AdminLogin-text2">{languageObj.text}</div>

          <div
            className="AdminLogin-inputFieldContainer"
            onKeyDown={handleKeyDown}
          >
            <Textbox
              id={"email"}
              name="email"
              type="text"
              placeholder={languageObj.inputFieldContainer}
              onChange={this.handleChange}
              value={this.state.username}
              classNameInput="AdminLogin-inputField"
              classNameContainer="AdminLogin-Container"
              validationCallback={(res) => {
                this.setState({
                  usernameHasErr: res,
                });
              }}
              onBlur={(e) => {}}
              validationOption={validLogin.username("")}
            />
            <div onClick={this.reroute} className="AdminLogin-nextBtn"></div>
          </div>
        </div>
      </div>
    );
  }
}
AdminLogin.propTypes = {
  languageObj: PropTypes.object,
};

export default AdminLogin;
